
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph, Anatomy, Link } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  The expandable is a <strong>progressive disclosure component</strong>. Such
  components truncate information for the general layout/design and are intended
  to <strong>deliver additional content depending on users' interests</strong>.
  They help keep the interface clean and reduce scrolling by saving vertical
  space, while being{' '}
  <strong>
    indicative of the additional content that is available through extra
    interaction
  </strong>
  .
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <Anatomy image="https://inno-ecl.s3.amazonaws.com/media/images/EC/Expandable/Expandable2.jpg" alt="Anatomy of the expandable" legend={{
      items: [{
        color: '#404040',
        label: 'Mandatory'
      }, {
        color: '#004494',
        label: 'Optional'
      }]
    }} mdxType="Anatomy" />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Button`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Actionable item (expands/collapses) - The button label must be short and `}<strong parentName="td">{`descriptive of the action that follows after being clicked`}</strong><br />{`Contains Label & Action indicator`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Action indicator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Varies depending on the state (collapsed/expanded). `}<strong parentName="td">{`Indicates what the next action will do - expands/collapses content container on click`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Content Container`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This element displays relevant content in a `}<strong parentName="td">{`container that's initially hidden`}</strong></td>
        </tr>
      </tbody>
    </table>
    <h2>{`Do's`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`use a button label for each item`}</strong>{` with a short, distinct and indicative title of the hidden content`}</li>
    </ul>
    <h2>{`Don'ts`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`don't use with large blocks of content`}</strong></li>
      <li parentName="ul"><strong parentName="li">{`don't hide important information`}</strong>{` that should be present at all times`}</li>
    </ul>
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul">{`use when additional information is offered that will `}<strong parentName="li">{`only benefit a small group of users`}</strong></li>
      <li parentName="ul">{`when you can `}<strong parentName="li">{`make extensive and complex content easier to digest through descriptive labels`}</strong></li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul">{`do not use as a button`}</li>
      <li parentName="ul">{`do not use it consecutively - use `}<Link to="/ec/components/accordion/usage/" mdxType="Link">{`accordions`}</Link>{` instead`}</li>
      <li parentName="ul">{`don't use when pages are short (reading time: under 3 minutes)`}</li>
    </ul>
    <h2>{`Notes`}</h2>
    <h3>{`Accessibility`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`progressive disclosure elements`}</strong>{` can be helpful accessibility aids as `}<strong parentName="li">{`they give users the choice of revealing content to read or bypass`}</strong>{`, making page navigation more efficient for screen-reader users and people using the keyboard or alternative input devices`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;